<template>
  <div class="service-payment-container">
    <ServicePay />
  </div>
</template>

<script>
import ServicePay from '@/components/Service/ServicePay.vue'
export default {
  components :{
    ServicePay
  },
  mounted() {
    window.scrollTo(0,0)
  }
}
</script>

<style scoped>
.service-payment-container {
  max-width: 552px;
  margin: 24px auto;
  padding: 24px;
  box-sizing: border-box;
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  font-family: var(--font-sans);
}
</style>